	<form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" formName="RloApplicationSearchForm" >

     <div class="header">
			<div class="primary-header">
			  <fpx-button className="back" btnType="button" label="Back" (onClick)="_helper.closeFilter()"></fpx-button>
			  <div class="title">Search</div>
			</div>

			<fpx-button className="close" btnType="button" (onClick)="_helper.closeFilter()"></fpx-button>

		  </div>

	 <box class="entry-form">

			  <app-tatBurstOn-control [keyword]="state.keyword" [customerName]="state.customerName" class="col-md-12"  placeholder="Search"  label=""   formControlName="search"
   ></app-tatBurstOn-control>
	 </box>
	</form>

